export const FEED_PLAY_POLICY_VERSION = 'feed-play-0.1.0';

/** Canonical presentation cadence for authored games. Games never receive a
 * member post ID, reading acknowledgement or inferred emotional signal. The
 * ordinal counts authorized, rendered posts across the whole frozen feed. */
export function feedGameAt(
  ordinal,
  { mode, scope, contentScope, format, enabled, gamesFeed },
  games,
) {
  if (
    !enabled ||
    gamesFeed === false ||
    scope !== 'all' ||
    contentScope !== 'ordinary' ||
    mode === 'latest' ||
    format === 'talk' ||
    !Number.isSafeInteger(ordinal) ||
    ordinal < 4 ||
    ordinal % 4 ||
    !games.length
  )
    return null;
  return games[(ordinal / 4 - 1) % games.length];
}

/** Reserve bounded authored moments without adding content or changing ordinary
 * relative order. The server supplies exact trusted activity bindings after ACL
 * checks. Apply separately to Unseen/Earlier partitions; chronology and deliberate
 * connection/learning views are never changed. */
export function reserveFeelingMoments(entries, moods, { mode, scope, contentScope, format }) {
  if (scope !== 'all' || contentScope !== 'ordinary' || mode === 'latest' || format === 'talk')
    return entries;
  const selected = ['calm', 'inspired', 'energized'].includes(mode)
    ? [mode]
    : mode === 'automatic'
      ? ['calm', 'inspired', 'energized']
      : [];
  if (!selected.length) return entries;
  const activities = entries.filter((entry) => selected.includes(moods.get(entry.id)));
  if (!activities.length) return entries;
  const chosen = selected.flatMap((mood) =>
    activities.filter((entry) => moods.get(entry.id) === mood),
  );
  // Round-robin preserves variety in automatic mode rather than exhausting Calm.
  const queues = selected.map((mood) => chosen.filter((entry) => moods.get(entry.id) === mood));
  const order = [];
  while (queues.some((queue) => queue.length))
    for (const queue of queues) {
      const entry = queue.shift();
      if (entry) order.push(entry);
    }
  const reserved = new Set(order.map((entry) => entry.id));
  const ordinary = entries.filter((entry) => !reserved.has(entry.id));
  const result = [];
  let nextSlot = selected.length === 1 ? 1 : 7;
  while (ordinary.length || order.length) {
    if (order.length && (result.length === nextSlot || !ordinary.length)) {
      result.push(order.shift());
      nextSlot = result.length + 11;
    } else result.push(ordinary.shift());
  }
  return result;
}
